import React, { useState, useEffect } from 'react'
import CloseIcon from '../../assets/CloseIcon'
import DotsIcon from '../../assets/DotsIcon'
import EditIcon from '../../assets/EditIcon'
import TrashIcon from '../../assets/TrashIcon'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import {
    getAllPOSHelper,
    addPOSHelper,
    updatePOSHelper,
    deletePOSHelper
} from '../../helper/pos-details-helper'
import { getAllBanksHelper } from '../../helper/bank-details-helper'

const POS_FIELDS = {
    ID: 'id',
    POS_ACCOUNT_NAME: 'pos_account_name',
    POS_BANK_ACCOUNT: 'pos_bank_account',
    PAYMENT_RECEIVER_BANK_ID: 'payment_receiver_bank_id',
    SAME_BANK_TRANSACTION_FEES: 'same_bank_transaction_fees',
    OTHER_BANK_TRANSACTION_FEES: 'other_bank_transaction_fees'
}

const POSDetails = ({ onBackClick, onClose }) => {
    const [posList, setPosList] = useState([])
    const [banks, setBanks] = useState([])
    const [open, setOpen] = useState(false)
    const [viewOpen, setViewOpen] = useState(false)
    const [posData, setPosData] = useState({})
    const [selectedPOS, setSelectedPOS] = useState(null)
    const [isFieldErrorVisible, setIsFieldErrorVisible] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [activeCardIndex, setActiveCardIndex] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        loadPOS()
        loadBanks()
    }, [])

    const loadPOS = () => {
        getAllPOSHelper()
            .then(res => {
                console.log('POS loaded: ', res)
                setPosList(res || [])
            })
            .catch(err => {
                console.log('Error loading POS: ', err)
                setPosList([])
            })
    }

    const loadBanks = () => {
        getAllBanksHelper()
            .then(res => {
                console.log('Banks loaded for dropdown: ', res)
                setBanks(res || [])
            })
            .catch(err => {
                console.log('Error loading banks: ', err)
                setBanks([])
            })
    }

    const handleDrawerToggle = () => {
        setOpen(!open)
        if (open) {
            resetForm()
        }
    }

    const handleViewDrawerToggle = () => {
        setViewOpen(!viewOpen)
        if (viewOpen) {
            setSelectedPOS(null)
        }
    }

    const handlePOSDetailUpdate = (key, value) => {
        setPosData({
            ...posData,
            [key]: value
        })
    }

    const resetForm = () => {
        setPosData({})
        setIsFieldErrorVisible(false)
        setIsEditMode(false)
    }

    const checkValidation = () => {
        return (
            posData[POS_FIELDS.POS_ACCOUNT_NAME] &&
            posData[POS_FIELDS.POS_BANK_ACCOUNT] &&
            posData[POS_FIELDS.PAYMENT_RECEIVER_BANK_ID]
        )
    }

    const handleSubmit = () => {
        if (!checkValidation()) {
            setIsFieldErrorVisible(true)
            return
        }

        setIsFieldErrorVisible(false)
        setIsLoading(true)

        if (isEditMode) {
            updatePOSHelper(posData)
                .then(res => {
                    console.log('POS updated: ', res)
                    loadPOS()
                    resetForm()
                    handleDrawerToggle()
                })
                .catch(err => {
                    console.log('Error updating POS: ', err)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        } else {
            addPOSHelper(posData)
                .then(res => {
                    console.log('POS added: ', res)
                    loadPOS()
                    resetForm()
                    handleDrawerToggle()
                })
                .catch(err => {
                    console.log('Error adding POS: ', err)
                })
                .finally(() => {
                    setIsLoading(false)
                })
        }
    }

    const handleViewPOS = (pos) => {
        setSelectedPOS(pos)
        setActiveCardIndex(null)
        setViewOpen(true)
    }

    const handleEditPOS = (pos) => {
        setPosData(pos)
        setIsEditMode(true)
        setActiveCardIndex(null)
        setOpen(true)
    }

    const handleDeletePOS = (posId) => {
        deletePOSHelper(posId)
            .then(res => {
                console.log('POS deleted: ', res)
                loadPOS()
            })
            .catch(err => {
                console.log('Error deleting POS: ', err)
            })
        setActiveCardIndex(null)
    }

    const toggleCardMenu = (index, e) => {
        e.stopPropagation()
        setActiveCardIndex(activeCardIndex === index ? null : index)
    }

    const getBankNameById = (bankId) => {
        const bank = banks.find(b => b.id === bankId)
        return bank ? bank.bank_name : '-'
    }

    return (
        <>
            <div className="pageBodyRightPanel">
                <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter webVisible mb-5">
                    <div className="pageBodyRightPanelHeading">POS Details</div>
                    <div className="addProductBtn dFlex aiCenter">
                        <button
                            className="btn btnPrimary"
                            onClick={handleDrawerToggle}>
                            ADD
                        </button>
                        {onClose && (
                            <div
                                className="pointer ml-4"
                                onClick={() => onClose()}>
                                <CloseIcon />
                            </div>
                        )}
                    </div>
                </div>

                <div className="pageBodyPanelWrap dFlex settingsDetailsContent">
                    <div className="pageBodyLeftPanel settingsDetailsList">
                {posList.length === 0 ? (
                    <div className="emptyState">
                        <p>No POS details added yet. Click ADD to add your first POS account.</p>
                    </div>
                ) : (
                    <div className="bankListWrap">
                        <table className="bankTable">
                            <thead>
                                <tr>
                                    <th>POS Bank's Details</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {posList.map((pos, index) => (
                                    <tr
                                        key={pos[POS_FIELDS.ID] || index}
                                        className="bankRow"
                                        onClick={() => handleViewPOS(pos)}>
                                        <td className="bankName">
                                            {pos[POS_FIELDS.POS_ACCOUNT_NAME]}
                                        </td>
                                        <td className="bankActions">
                                            <div className="actionWrapper">
                                                <span
                                                    className="dotsIcon pointer"
                                                    onClick={(e) => toggleCardMenu(index, e)}>
                                                    <DotsIcon />
                                                </span>
                                                {activeCardIndex === index && (
                                                    <ul className="cardActionsWrapper show">
                                                        <li
                                                            className="actionItem"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleEditPOS(pos)
                                                            }}>
                                                            <EditIcon /> Edit
                                                        </li>
                                                        <li
                                                            className="actionItem"
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                handleDeletePOS(pos[POS_FIELDS.ID])
                                                            }}>
                                                            <TrashIcon /> Delete
                                                        </li>
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                    </div>
                </div>

                {/* Add/Edit POS Drawer */}
                <SideDrawer
                    handleDrawerToggle={handleDrawerToggle}
                    open={open}
                    downloadButton={true}
                    downloadText={'SAVE'}
                    drawerHeading={isEditMode ? 'Edit POS Account' : 'Add New POS Account'}
                    handleClick={() => handleSubmit()}
                    isLoading={isLoading}>
                    <div className="wizardFieldset">
                        <form className="mt-5">
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="posAccountName"
                                    placeholder="POS Account Name"
                                    value={posData[POS_FIELDS.POS_ACCOUNT_NAME] || ''}
                                    onChange={e =>
                                        handlePOSDetailUpdate(
                                            POS_FIELDS.POS_ACCOUNT_NAME,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="posAccountName">POS Account Name</label>
                                {isFieldErrorVisible &&
                                    !posData[POS_FIELDS.POS_ACCOUNT_NAME] && (
                                        <div className="invalidFeedback">
                                            Please enter POS Account Name.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="text"
                                    className="formControl"
                                    id="posBankAccount"
                                    placeholder="POS Bank Account"
                                    value={posData[POS_FIELDS.POS_BANK_ACCOUNT] || ''}
                                    onChange={e =>
                                        handlePOSDetailUpdate(
                                            POS_FIELDS.POS_BANK_ACCOUNT,
                                            e.target.value
                                        )
                                    }
                                    required
                                />
                                <label htmlFor="posBankAccount">POS Bank Account</label>
                                {isFieldErrorVisible &&
                                    !posData[POS_FIELDS.POS_BANK_ACCOUNT] && (
                                        <div className="invalidFeedback">
                                            Please enter POS Bank Account.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <select
                                    className="formControl"
                                    id="paymentReceiverBank"
                                    value={posData[POS_FIELDS.PAYMENT_RECEIVER_BANK_ID] || ''}
                                    onChange={e =>
                                        handlePOSDetailUpdate(
                                            POS_FIELDS.PAYMENT_RECEIVER_BANK_ID,
                                            e.target.value
                                        )
                                    }
                                >
                                    <option value="">Select Bank</option>
                                    {banks.map((bank) => (
                                        <option key={bank.id} value={bank.id}>
                                            {bank.bank_name}
                                        </option>
                                    ))}
                                </select>
                                <label htmlFor="paymentReceiverBank">Payment Receiver Bank</label>
                                {isFieldErrorVisible &&
                                    !posData[POS_FIELDS.PAYMENT_RECEIVER_BANK_ID] && (
                                        <div className="invalidFeedback">
                                            Please select Payment Receiver Bank.
                                        </div>
                                    )}
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="number"
                                    className="formControl"
                                    id="sameBankTransactionFees"
                                    placeholder="Same Bank Transaction Fees (%)"
                                    value={posData[POS_FIELDS.SAME_BANK_TRANSACTION_FEES] || ''}
                                    onChange={e =>
                                        handlePOSDetailUpdate(
                                            POS_FIELDS.SAME_BANK_TRANSACTION_FEES,
                                            e.target.value
                                        )
                                    }
                                    min="0"
                                    step="0.01"
                                />
                                <label htmlFor="sameBankTransactionFees">Same Bank Transaction Fees (%)</label>
                            </div>
                            <div className="formGroup formFloating fgrow1">
                                <input
                                    type="number"
                                    className="formControl"
                                    id="otherBankTransactionFees"
                                    placeholder="Other Bank Transaction Fees (%)"
                                    value={posData[POS_FIELDS.OTHER_BANK_TRANSACTION_FEES] || ''}
                                    onChange={e =>
                                        handlePOSDetailUpdate(
                                            POS_FIELDS.OTHER_BANK_TRANSACTION_FEES,
                                            e.target.value
                                        )
                                    }
                                    min="0"
                                    step="0.01"
                                />
                                <label htmlFor="otherBankTransactionFees">Other Bank Transaction Fees (%)</label>
                            </div>
                        </form>
                    </div>
                </SideDrawer>

                {/* View POS Drawer */}
                <SideDrawer
                    handleDrawerToggle={handleViewDrawerToggle}
                    open={viewOpen}
                    drawerHeading="POS Details">
                    {selectedPOS && (
                        <div className="wizardFieldset">
                            <div className="bankViewDetails mt-5">
                                <div className="viewItem">
                                    <div className="viewLabel">POS Account Name</div>
                                    <div className="viewValue">
                                        {selectedPOS[POS_FIELDS.POS_ACCOUNT_NAME] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">POS Bank Account</div>
                                    <div className="viewValue">
                                        {selectedPOS[POS_FIELDS.POS_BANK_ACCOUNT] || '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Payment Receiver Bank</div>
                                    <div className="viewValue">
                                        {getBankNameById(selectedPOS[POS_FIELDS.PAYMENT_RECEIVER_BANK_ID])}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Same Bank Transaction Fees</div>
                                    <div className="viewValue">
                                        {selectedPOS[POS_FIELDS.SAME_BANK_TRANSACTION_FEES] ? `${selectedPOS[POS_FIELDS.SAME_BANK_TRANSACTION_FEES]}%` : '-'}
                                    </div>
                                </div>
                                <div className="viewItem">
                                    <div className="viewLabel">Other Bank Transaction Fees</div>
                                    <div className="viewValue">
                                        {selectedPOS[POS_FIELDS.OTHER_BANK_TRANSACTION_FEES] ? `${selectedPOS[POS_FIELDS.OTHER_BANK_TRANSACTION_FEES]}%` : '-'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </SideDrawer>
            </div>
        </>
    )
}

export default POSDetails
